
  import { CommonModule } from '@angular/common';
  import { Component, Input, input } from '@angular/core';
  import { HTTPMethod } from 'src/app/constants/enum';
  
  
  @Component({
    selector: 'app-loader',
    standalone: true,
    imports: [CommonModule],
    template: `<div class="loader"></div>`
  })
  export class LoaderComponent {
  
    getColor(value:any){
      if(HTTPMethod.GET == value){
        return 'bg-success'
      }
      return 'bg-default';
    }
  }
  